import { Link } from "react-router-dom";
import { ArrowRight, Heart } from "lucide-react";
import PageHero from "@/components/PageHero";
import RichText from "@/components/RichText";
import { Reveal, PrimaryButton } from "@/components/primitives";
import Snippet from "@/components/Snippet";
import { useSite } from "@/context/SiteContext";
import { ASSETS, PRACTITIONER } from "@/data/content";

export default function AboutIsabelle() {
  const { page, img, settings } = useSite();
  const p = page("about_isabelle");
  const photo = img("about_isabelle_photo", ASSETS.womanField);

  return (
    <div>
      <PageHero {...p.hero} />

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-5 gap-14 items-start">
          <Reveal className="lg:col-span-2">
            <img src={photo} alt="Isabelle Legér" className="rounded-3xl object-cover w-full h-[34rem] shadow-[0_20px_60px_rgba(59,92,69,0.14)] sticky top-28" />
          </Reveal>
          <Reveal delay={0.12} className="lg:col-span-3">
            <RichText html={p.body_html} />
            <div className="flex items-center gap-3 pt-4">
              <Heart className="text-brand-lavender-dark" strokeWidth={1.5} />
              <span className="font-script text-3xl text-brand-lavender-dark">Isabelle</span>
            </div>

            <div className="mt-10 rounded-3xl border border-brand-line bg-white p-8">
              <p className="font-body text-sm uppercase tracking-[0.22em] text-brand-lavender-dark mb-4"><Snippet k="about_isabelle.find_heading" fallback="Where to find me" /></p>
              <ul className="space-y-2 font-body text-brand-slate">
                <li><strong className="text-brand-ink">Location:</strong> {settings.location || PRACTITIONER.location}</li>
                <li><strong className="text-brand-ink">Email:</strong> <a href={`mailto:${settings.email || PRACTITIONER.email}`} className="hover:text-brand-forest transition-colors">{settings.email_display || PRACTITIONER.emailDisplay || settings.email || PRACTITIONER.email}</a></li>
                <li><strong className="text-brand-ink">Phone:</strong> {settings.phone || PRACTITIONER.phone}</li>
              </ul>
              <div className="mt-7">
                <PrimaryButton as={Link} to="/volunteer" data-testid="isabelle-volunteer-btn">
                  <Snippet k="about_isabelle.cta" fallback="Volunteer for a session" /> <ArrowRight size={18} strokeWidth={1.5} />
                </PrimaryButton>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
